module.exports = __webpack_public_path__ + "static/media/mentora_backend_logo.ad8b958d.png";